import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/App/Layout";
import Navbar from "../../components/App/Navbar";
import Footer from "../../components/App/Footer";
import CareerPlatformContent, {
  CAREER_PLATFORM_URL,
} from "../../components/CareerPlatform/CareerPlatformContent";

const pageUrl =
  "https://cloudlogicit.com.au/solutions/career-application-platform";
const title = "AI Resume & Job Application Platform | CloudLogic";
const description =
  "Create a tailored resume and cover letter using your existing career experience and the requirements of the role you're applying for with CloudLogic's career application platform.";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "CloudLogic Career AI",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  url: CAREER_PLATFORM_URL,
  description,
  publisher: {
    "@type": "Organization",
    name: "CloudLogic IT Solutions",
    url: "https://cloudlogicit.com.au/",
  },
  offers: {
    "@type": "Offer",
    url: CAREER_PLATFORM_URL,
    availability: "https://schema.org/InStock",
  },
};

const CareerApplicationPlatformPage = () => {
  return (
    <Layout>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta
          name="keywords"
          content="AI resume builder Australia, ATS-friendly resume builder, tailored resume builder, job application assistant, AI cover letter builder, professional resume builder Australia"
        />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={pageUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <Navbar />
      <CareerPlatformContent />
      <Footer />
    </Layout>
  );
};

export default CareerApplicationPlatformPage;
